import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AbstractDashboardDetailsService } from '../abstraction/abstract.dashboard-details.service';
import { IFedNowDetails } from '../../interfaces/fednow-details.interface';
import { IRtpDetails } from '../../interfaces/rtp-details.interface';
@Injectable({
  providedIn: 'root',
})
export class DashboardDetailsService extends AbstractDashboardDetailsService {
  controller = `/manager/dashboard`;
  urlGetFedNowDetails = `${environment.apiUrl}${this.controller}/getfednowdetails`;
  urlGetRTPDetails = `${environment.apiUrl}${this.controller}/getrtpdetails`;
  constructor(private http: HttpClient) {
    super();
  }

  override getFedNowDetails(): Promise<IFedNowDetails | undefined> {
    return this.http.get<IFedNowDetails>(`${this.urlGetFedNowDetails}`).toPromise();
  }
  override getRtpDetails(): Promise<IRtpDetails | undefined> {
    return this.http.get<IRtpDetails>(`${this.urlGetRTPDetails}`).toPromise();
  }
}
